function isProduction (env = process.env) {
  return env.NODE_ENV === 'production'
}

function isDevelopment (env = process.env) {
  return env.NODE_ENV === 'development'
}

// Only production includes 'app' in the domain url
const getIsProductionDomain = (matchUrl = window.location.href) => matchUrl.includes('app')

const isReviewApp = (matchUrl = window.location.href) => matchUrl.includes('reviews.getrodeo')

module.exports = {
  isProduction,
  isDevelopment,
  getIsProductionDomain,
  isReviewApp
}
